import {
  createAsyncThunk,
  createSlice /*PayloadAction,*/,
} from '@reduxjs/toolkit';
// import { RootState } from '../store/store';
// import { saleAPI } from '../../api/saleAPI';
const name = 'sale';

export const fetchReferralCodeList = createAsyncThunk(
  `${name}/fetchReferralCodeList`, // 액션 이름을 정의해 주도록 합니다.
  async (thunkAPI) => {
    // try {
    //   return '';
    // } catch (e) {
    //   return thunkAPI.rejectWithValue(await e.response.data);
    // }
    return '';
  },
);

// export interface saleState {
//     // nft 판매 관련 변수
//     // 현재 세일 기간
//     saleId: string;
//     // 현재 기간 잔량
//     totalAmount: string;
//     totalAmountUpdated: boolean;
//     totalAmountUpdateSaleId:string;
//     // 현재 가격
//     price: string;
//     // 연결된 지갑 구매 가능 갯수
//     amount: string;
//     soldOut: boolean;
//     wei:string;
// }

// const initialState: saleState = {
//     saleId : "",
//     totalAmount : "",
//     totalAmountUpdated:false,
//     totalAmountUpdateSaleId: "",
//     price : "",
//     amount : "0",
//     soldOut : false,
//     wei:"0",
// }

const initialState = {
  saleId: '',
  totalAmount: '',
  totalAmountUpdated: false,
  totalAmountUpdateSaleId: '',
  price: '',
  amount: '0',
  soldOut: false,
  wei: '0',
};

// export const saleSlice = createSlice({
//   name: name,
//   initialState,
//   reducers: {
//     setSaleId: (state, action: PayloadAction<string>) => {
//       state.saleId = action.payload !== null ? action.payload : '';
//       state.totalAmountUpdated = false;
//     },
//     setTotalAmount: (state, action: PayloadAction<string>) => {
//       state.totalAmount = action.payload !== null ? action.payload : '';
//       state.totalAmountUpdated = true;
//     },
//     setTotalAmountUpdateSaleId: (state, action: PayloadAction<string>) => {
//       state.totalAmountUpdateSaleId =
//         action.payload !== null ? action.payload : '';
//     },
//     setPrice: (state, action: PayloadAction<string>) => {
//       state.price = action.payload !== null ? action.payload : '';
//     },
//     setAmount: (state, action: PayloadAction<string>) => {
//       state.amount = action.payload !== null ? action.payload : '0';
//     },
//     setSoldOut: (state, action: PayloadAction<boolean>) => {
//       state.soldOut = action.payload;
//     },
//     setWei: (state, action: PayloadAction<string>) => {
//       state.wei = action.payload;
//     },
//   },
// });

export const saleSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    setSaleId: (state, action) => {
      state.saleId = action.payload !== null ? action.payload : '';
      state.totalAmountUpdated = false;
    },
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload !== null ? action.payload : '';
      state.totalAmountUpdated = true;
    },
    setTotalAmountUpdateSaleId: (state, action) => {
      state.totalAmountUpdateSaleId =
        action.payload !== null ? action.payload : '';
    },
    setPrice: (state, action) => {
      state.price = action.payload !== null ? action.payload : '';
    },
    setAmount: (state, action) => {
      state.amount = action.payload !== null ? action.payload : '0';
    },
    setSoldOut: (state, action) => {
      state.soldOut = action.payload;
    },
    setWei: (state, action) => {
      state.wei = action.payload;
    },
  },
});

export const {
  setSaleId,
  setTotalAmount,
  setTotalAmountUpdateSaleId,
  setPrice,
  setAmount,
  setSoldOut,
  setWei,
} = saleSlice.actions;

export default saleSlice.reducer;
